import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from '~/hooks';
import * as Service from '../services/GetDiscountCodes';

/**
 * Query keys for the office's discount-code history. Office-scoped: switching
 * DSO child must re-fetch, because codes belong to the child office the request
 * is bound to (`x-office`), not to the signed-in parent.
 */
export const discountCodeKeys = {
  all: ['applied-codes'] as const,
  list: (officeId?: string | null) => [...discountCodeKeys.all, 'list', officeId] as const,
};

/**
 * Every discount code this office holds, for the Promo Codes list on Payment
 * Information.
 *
 * @returns discountCodes, isLoading, isError, refetch
 */
export const useGetDiscountCodes = () => {
  const selectedOfficeId = useAppSelector((state) => state.user.selectedOfficeId);

  const query = useQuery({
    queryKey: discountCodeKeys.list(selectedOfficeId),
    queryFn: () => Service.getDiscountCodes(),
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    discountCodes: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
